:host([light]) {
    & .poo_st0 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_1_);
    }
    & .poo_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000089573257442342782390000012284668864103447480_);
    }
    & .poo_st2 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000085245946306145156190000003862902867651220864_);
    }
    & .poo_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000108992451947377227090000011600597148902550189_);
    }
    & .poo_st4 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000012458192922347346280000012361196751308525759_);
    }
    & .poo_st5 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000160191581925305637630000010549156901913417383_);
    }
    & .poo_st6 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000096048788011364814450000016428087855719395979_);
    }
    & .poo_st7 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000006696993435821807220000010563927323665433022_);
    }
    & .poo_st8 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000119081191756132882550000005809447072890554250_);
    }
    & .poo_st9 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000106137584560179492080000013988506282117794446_);
    }
    & .poo_st10 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }
    & .poo_st11 {
        fill: #1a4e85;
    }
    & .poo_st12 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 8.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
}
:host([dark]) {
    & .poo_st0 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_1_);
    }
    & .poo_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000126301561926409989080000001427166702884057224_);
    }
    & .poo_st2 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000166637219427090646580000013637641716218298290_);
    }
    & .poo_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000156565291910208903800000014815804483471938449_);
    }
    & .poo_st4 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000026165679946014121920000008335880654947611277_);
    }
    & .poo_st5 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000069375637448186722360000008334223594870319239_);
    }
    & .poo_st6 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000057140395052614283960000017943023735563665070_);
    }
    & .poo_st7 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000028293937169592293130000003083567536435407499_);
    }
    & .poo_st8 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000114047232530517612570000006348591706432236432_);
    }
    & .poo_st9 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#poo_SVGID_00000035521205617809834750000013790179831538901932_);
    }
    & .poo_st10 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ced4db;
    }
    & .poo_st11 {
        fill: #09264a;
    }
    & .poo_st12 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 8.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
}
